import { useState, FormEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useChangePassword, ChangePasswordForm, AuthError } from '@auth';

export default function SecurityPanel() {
  const intl = useIntl();
  const changePassword = useChangePassword();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (newPassword !== confirmPassword) {
      setError(intl.formatMessage({ id: 'settings.changePassword.passwordMismatch' }));
      return;
    }

    try {
      await changePassword.mutateAsync({ currentPassword, newPassword });
      setSuccess(true);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error_) {
      const authError = error_ as AuthError;
      setError(authError.error ?? intl.formatMessage({ id: 'settings.changePassword.passwordMismatch' }));
    }
  };

  return (
    <div className="space-y-6">
      {success && (
        <div className="rounded-lg bg-green-50 p-4 text-green-800">
          <FormattedMessage id="settings.changePassword.success" />
        </div>
      )}
      <ChangePasswordForm
        currentPassword={currentPassword}
        newPassword={newPassword}
        confirmPassword={confirmPassword}
        error={error}
        isLoading={changePassword.isPending}
        onCurrentPasswordChange={setCurrentPassword}
        onNewPasswordChange={setNewPassword}
        onConfirmPasswordChange={setConfirmPassword}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
